import { Link } from "react-router-dom";
import cn from "classnames";

import withLayoutOptions from "../../components/withLayoutOptions/withLayoutOptions";

import useImgSet from "../../hooks/useImgSet";

import s from "./PageKidB.module.scss";

function PageKidB() {
  const getImgSet = useImgSet();

  const description = getImgSet("description__p04", "png", s.description);
  const notice = getImgSet("notice__p04", "png");
  const item01 = getImgSet("item__01__p04", "png", [s.item, s.item__01]);
  const item02 = getImgSet("item__02__p04", "png", [s.item, s.item__02]);
  const item03 = getImgSet("item__03__p04", "png", [s.item, s.item__03]);
  const pointer = getImgSet("pointer__kid", "png", s.pointer);

  const back = getImgSet("back__p22", "png");
  const imgA = getImgSet("bear__03", "png", s.img__a);
  const imgB = getImgSet("img__p04", "png", s.img__b);

  return (
    <div className={s.root}>
      {pointer}
      <div className={s.aside_left}>
        <Link to="/kid/" className={s.back}>
          {back}
        </Link>
        {imgA}
        <Link to="/kid/c" className={s.notice}>
          {notice}
        </Link>
      </div>
      <div className={s.inner}>
        <div className={cn(s.item, s.item__01)}>
          {item01}
          {imgB}
        </div>
        {item02}
        {item03}
      </div>
      <div className={s.aside_right}>{description}</div>
    </div>
  );
}

export default withLayoutOptions(PageKidB);
